var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5763 1.45113C11.8106 1.21681 12.1905 1.21681 12.4249 1.45113L16.9249 5.95113C17.1592 6.18544 17.1592 6.56534 16.9249 6.79965C16.6905 7.03397 16.3106 7.03397 16.0763 6.79965L12.6004 3.32372V13.1254C12.6004 13.4568 12.3318 13.7254 12.0004 13.7254C11.669 13.7254 11.4004 13.4568 11.4004 13.1254V3.32412L7.92485 6.79965C7.69054 7.03397 7.31064 7.03397 7.07632 6.79965C6.84201 6.56534 6.84201 6.18544 7.07632 5.95113L11.5763 1.45113ZM4.12539 11.3504C3.83544 11.3504 3.60039 11.5854 3.60039 11.8754V21.0004C3.60039 21.2903 3.83544 21.5254 4.12539 21.5254H19.8754C20.1653 21.5254 20.4004 21.2903 20.4004 21.0004V11.8754C20.4004 11.5854 20.1653 11.3504 19.8754 11.3504H17.6254C17.294 11.3504 17.0254 11.0818 17.0254 10.7504C17.0254 10.419 17.294 10.1504 17.6254 10.1504H19.8754C20.8281 10.1504 21.6004 10.9227 21.6004 11.8754V21.0004C21.6004 21.9531 20.8281 22.7254 19.8754 22.7254H4.12539C3.1727 22.7254 2.40039 21.9531 2.40039 21.0004V11.8754C2.40039 10.9227 3.1727 10.1504 4.12539 10.1504H6.37539C6.70676 10.1504 6.97539 10.419 6.97539 10.7504C6.97539 11.0818 6.70676 11.3504 6.37539 11.3504H4.12539Z",
    fill: "#101010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/ShareIcon.1790217e799843d64061e010cf14b178.svg";
export { ForwardRef as ReactComponent };